import React from "react";
import { Link } from "react-router-dom";

/**
 * Footer — site-wide footer with social links, about us, and Quran seminars info.
 */
function Footer() {
  return (
    <footer className="footer-section mt-auto">
      <div className="container py-5">
        <div className="row g-4">
          {/* Brand + Social */}
          <div className="col-md-4">
            <h5 className="footer-brand mb-3">Al-Yasin</h5>
            <p className="footer-text small">
              Koranundervisning, kulturelle aktiviteter og forebyggende arbeid
              for barn og unge.
            </p>
            <div className="d-flex gap-3 mt-3">
              <a href="https://facebook.com" target="_blank" rel="noreferrer" className="footer-social" aria-label="Facebook">
                <i className="bi bi-facebook"></i> Facebook
              </a>
              <a href="https://instagram.com" target="_blank" rel="noreferrer" className="footer-social" aria-label="Instagram">
                <i className="bi bi-instagram"></i> Instagram
              </a>
              <a href="https://youtube.com" target="_blank" rel="noreferrer" className="footer-social" aria-label="YouTube">
                <i className="bi bi-youtube"></i> YouTube
              </a>
            </div>
          </div>

          {/* Quick Links / About Us */}
          <div className="col-md-4">
            <h6 className="text-gold fw-bold mb-3">Om Oss</h6>
            <ul className="list-unstyled footer-links">
              <li><Link to="/" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Hjem</Link></li>
              <li><Link to="/om-oss" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Om Al-Yasin</Link></li>
              <li><Link to="/signup">Bli Medlem</Link></li>
              <li><Link to="/login">Logg Inn</Link></li>
            </ul>
          </div>

          {/* Quran Seminars */}
          <div className="col-md-4">
            <h6 className="text-gold fw-bold mb-3">Quran-seminarer</h6>
            <p className="footer-text small">
              Vi arrangerer jevnlige seminarer med fokus på tajweed, hifz og
              tafsir. Seminarene er åpne for alle nivåer og ledes av erfarne
              lærere.
            </p>
            <p className="footer-text small mb-0">
              📍 Sted: <strong className="text-white">Al-Yasin-senteret</strong>
            </p>
          </div>
        </div>

        {/* Bottom bar */}
        <hr className="border-secondary mt-4 mb-3" />
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
          <small className="footer-text">
            &copy; {new Date().getFullYear()} Al-Yasin Organisation: 936 686 958. Alle rettigheter reservert.
          </small>
          <small className="footer-text mt-2 mt-md-0">
            Laget med ❤️ for lokalsamfunnet
          </small>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
